<template>
  <div class="head-item">
    <div class="optionsBtn" v-if="userInfoData.user_id == mes.publisher.id">
      <div @click="goTop">置顶</div>
      <div @click="goRefresh">往前刷新</div>
      <div @click="goDownInfo">下架</div>
    </div>
    <div class="head-item-top c-c">
      <div class="flex1 c-l">
        <div @click="goToShop" v-if="mes.shop && mes.shop.has_shop == 1" class="main-pic">
          <img
            :src="
              mes.publisher.avatar_url
                ? mes.publisher.avatar_url
                : 'http://cdn11.jfbst.com/statics/head2.gif'
            "
          />
          <img src="../assets/images/images/plus.png" />
        </div>
        <div v-else class="main-pic">
          <img
            :src="
              mes.publisher.avatar_url
                ? mes.publisher.avatar_url
                : 'http://cdn11.jfbst.com/statics/head2.gif'
            "
          />
        </div>
        <div class="main-tag c-c-l f-d-c">
          <div style="display: flex; align-items: center">
            <div class="tag-small c-c">
              <div style="position: relative;" v-if="mes.svip_level.vip + mes.svip_level.svip">
                <img src="../assets/images/images/svipImg.png" alt />
                <div class="vip-dengji">{{mes.svip_level.vip + mes.svip_level.svip}}</div>
              </div>
            </div>
            <div class="f11 t128" style="margin:0;text-align:left;">{{ mes.region_text }}</div>
          </div>
          <!-- <div class="f11 t128" >{{ mes.publisher.nickname == '无'? ('来自ip' + mes.ip.split('.')[0] + '.' + mes.ip.split('.')[1]+ '.' + mes.ip.split('.')[2] + '.*** ' + '的用户') : mes.publisher.nickname}}</div> -->
          <div class="f11 t128" style="text-align: left">
            {{
              mes.publisher.nickname == "无"
                ? "IP：" + mes.ip_hidden
                : mes.publisher.nickname
            }}
          </div>
        </div>
      </div>
      <!--店铺信息-->
      <div
        @click="goToShop2"
        class="shopBtn"
        v-if="mes.shop && mes.shop.has_good == 1 && pics.length > 0"
      >
        店铺主页
      </div>
      <div
        v-if="
          mes.publisher.id != 0 &&
          userInfoData &&
          userInfoData.user_id != mes.publisher.id
        "
        style="width: 23px; height: 20px; margin-right: 5px"
        @click="goSendMessage"
      >
        <img
          style="width: 100%; height: 100%"
          src="../assets/images/images/message.png"
          alt
        />
      </div>
      <div class="phone">
        <a :href="relPhone">
          <img v-if="mes.phone" src="../assets/images/images/tel_1.gif" alt />
        </a>
        <img v-if="!mes.phone" src="../assets/images/images/noPhone.png" alt />
      </div>
    </div>
    <div :class="bigPic ? 'main-mes' : 'main-mes van-hairline--bottom'">
      <!-- <div class="car_info" v-if="mes.car_info">
        <div class="car_item">
          <div style="letter-spacing: 5px;">出发地：</div>
          <div>{{mes.car_info['出发地']}}</div>
        </div>
        <div class="car_item">
          <div style="letter-spacing: 5px;">目的地：</div>
          <div>{{mes.car_info['目的地']}}</div>
        </div>
        <div class="car_item">
          <div>出发时间：</div>
          <div>{{mes.car_info['出发时间']}}</div>
        </div>
      </div> -->
      <div
        class="t-l f15"
        style="
          width: 100%;
          position: relative;
          word-break: break-all;
          white-space: break-spaces;
          min-height: 65px;
        "
        @click="toggleShow(mes.content)"
        v-toggleContent="mes.is_recommend"
        v-html="content"
      ></div>
      <div v-if="mes.category && mes.category.id == '1'" class="base_info" @click="showCompanyInfo">单位基本情况</div>
    </div>
    <!--仅成品板块展示-->
    <div
      class="flex1 c-c van-hairline--bottom"
      v-if="bigPic"
      style="padding-bottom: 5px"
    >
      <div
        class="man-pic2"
        v-for="(item, index) in pics"
        :key="index"
        @click="previewPic(index)"
      >
        <img :src="item" alt />
      </div>
    </div>
    <div class="c-c head-item-bottom">
      <div class="c-l flex1 f11 one-hour" style="flex-grow: 2">
        更新:{{ mes.published_time }}
        <span
          @click="showRefreshInfo"
          style="color: #882784"
          v-if="mes.is_vip_refresh != '0'"
          >【刷新】</span
        >
      </div>
      <div class="flex1 c-c" v-if="!bigPic">
        <div
          class="man-pic"
          v-for="(item, index) in pics"
          :key="index"
          @click="previewPic(index)"
        >
          <img :src="item" alt />
        </div>
      </div>
      <div
        v-if="showClose"
        style="
          position: fixed;
          bottom: 100px;
          left: 0px;
          width: 100%;
          display: flex;
          justify-content: center;
          z-index: 9999;
        "
      >
        <img
          @click="closeImg"
          style="width: 30px; height: 30px"
          src="../assets/images/images/close.png"
          alt
        />
      </div>
      <div @click="warn()" class="c-end flex1 f11 one-hour">纠错/举报</div>
    </div>
    <!-- <DrawUp :class="showDrawUp == true? 'Sh': 'Hi'" @close="close"></DrawUp> -->
    <template v-if="actions.length">
      <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    </template>
    <van-popup v-model="showCompanyInfoPopup" position="bottom" :style="{ height: '50%' }" :safe-area-inset-bottom="true">
      <div class="company-info-popup">
        <div class="company-info-header">
          <span class="company-info-title">单位基本情况</span>
          <van-icon name="cross" @click="showCompanyInfoPopup = false" />
        </div>
        <div class="company-info-content">
          <div class="company-info-item">
            <span class="company-info-value">{{ companyInfo.companyName }}{{ companyInfo.description }}</span>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="pp">
      <van-image-preview
        v-model="showPreview"
        :images="images"
      ></van-image-preview>
    </div>
  </div>
</template>

<script>
let me;
let instance;
import { ActionSheet } from "vant";
import { ImagePreview } from "vant";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import DrawUp from "./DrawUp";
export default {
  name: "HeadItemWithoutZD",
  data() {
    return {
      showClose: false,
      images: [],
      showCompanyInfoPopup: false,
      realImages: [],
      realSmallImages: [],
      showPreview: false,
      showDrawUp: false,
      show: false,
      userInfoData: "", //用户个人信息
      companyInfo: {
        companyName: "",
        description: ""
      }
    };
  },
  mounted() {
    me = this;
    let userInfo = sessionStorage.getItem("userInfoData");
    this.userInfoData = JSON.parse(userInfo);
  },
  computed: {
    actions() {
      let arr = [];
      if (this.$store.state.nowActions !== "[]") {
        arr = this.$store.state.nowActions;
      } else {
        arr = JSON.parse(sessionStorage.getItem("nowActions"));
      }
      let arr1 = [];
      if (arr.length != 0) {
        for (let a = 0; a < arr.length; a++) {
          let id = arr[a].id;
          let name = arr[a].title;
          arr1.push({ id: id, name: name });
        }
      }
      return arr1;
    },
    content() {
      return this.mes.content;
    },
    relPhone() {
      return this.mes.phone ? "tel:" + this.mes.phone : "";
    },
    pics() {
      if (this.mes.thumbs.length != 0) {
        this.realImages = [];
        this.realSmallImages = [];
        for (let a = 0; a < this.mes.thumbs.length; a++) {
          this.realImages.push(this.mes.thumbs[a].path_url);
          this.realSmallImages.push(this.mes.thumbs[a].small_path_url);
        }
        this.images = this.realImages;
        if (this.bigPic) {
          return this.realSmallImages.slice(0, 3);
        } else {
          return this.realSmallImages.slice(0, 3);
        }
      } else {
        // return this.images;
      }
    },
  },
  methods: {
    //跳转到发送消息页面
    goSendMessage() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      let me = this;
      postData('/user/letter/quote',{
        message_id: me.mes.id
      }).then(res => {
        me.$router.push({
          path: "sendMessage",
          query: {
            receiveId: me.mes.publisher.id,
            sendId: me.userInfoData.user_id,
            fromId: me.mes.id,
          },
        });
      })
      
    },
    //获取用户信息
    getUserInfo() {
      let me = this;
      getData("/user/info", {
        token: localStorage.getItem("token")
          ? localStorage.getItem("token")
          : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
      })
        .then((res) => {
          if (res.code == 0) {
            me.userInfoData = Object.assign({}, res.data);
          }
        })
        .catch((err) => {});
    },
    //置顶
    goTop() {
      this.$router.push({
        path: "myPushMsg",
        query: {
          id: this.mes.id,
          type: "goTop",
        },
      });
    },
    //往前刷新
    goRefresh() {
      this.$router.push({
        path: "myPushMsg",
        query: {
          id: this.mes.id,
          type: "goRefresh",
        },
      });
    },
    //下架
    goDownInfo() {
      this.$router.push({
        path: "myPushMsg",
        query: {
          id: this.mes.id,
          type: "goDownInfo",
        },
      });
    },
    showRefreshInfo() {
      this.$toast("用户可购买VIP刷新权限自行刷新信息!");
    },
    goToShop2() {
      this.$store.commit("UPDATEATBINDEX", { tag: 7 });
      let me = this;
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "goods",
          id: me.mes.shop.id,
        },
      });
    },
    goToShop() {
      let me = this;
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: me.mes.shop.id,
        },
      });
    },
    closeImg() {
      this.showClose = false;
      if (instance) {
        instance.close();
      }
    },
    previewPic(index) {
      this.showClose = true;
      instance = ImagePreview({
        images: this.images,
        asyncClose: true,
        startPosition: index,
      });
    },
    onSelect(item) {
      let param = {
        message_id: this.mes.id - 0,
        option_id: item.id - 0,
      };

      postData("/report", param)
        .then((res) => {
          this.show = false;
          this.$toast("纠错成功");
        })
        .catch((err) => {
          this.show = false;
          this.$toast("纠错失败,请加客服对接!");
        });
    },
    getList() {
      getData("/recommend-lists", {}).then((res) => {});
    },
    toggleShow(index) {},
    warn() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("请先登录~");
        return;
      }
      this.$router.push({
        path: "errorReport",
        query: {
          tipsID: this.mes.id,
        },
      });
    },
    close() {
      this.showDrawUp = false;
    },
    showCompanyInfo() {
      let me = this;
      
      if (me.mes.company_name) {
        me.companyInfo.companyName = me.mes.company_name;
        me.getCompanyDescription(me.mes.company_name);
      } else {
        let companyName = me.extractCompanyName(me.mes.content);
        me.companyInfo.companyName = companyName;
        me.getArticleDescription();
      }
      
      me.showCompanyInfoPopup = true;
    },
    extractCompanyName(content) {
      let me = this;
      let companyName = "";
      
      const patterns = [
        /公司名称[：:]\s*([^\n]+)/,
        /单位[：:]\s*([^\n]+)/,
        /企业[：:]\s*([^\n]+)/
      ];
      
      for (let pattern of patterns) {
        let match = content.match(pattern);
        if (match) {
          companyName = match[1] || match[0];
          break;
        }
      }
      
      return companyName.trim();
    },
    getCompanyDescription(companyName) {
      let me = this;
      me.companyInfo.description = "加载中...";
      
      getData("/company/search", {
        name: companyName
      })
        .then((res) => {
          if (res.code == 0 && res.data) {
            me.companyInfo.description = res.data[0].desc || "暂无简介";
          } else {
            me.companyInfo.description = "暂无简介";
          }
        })
        .catch((err) => {
          me.companyInfo.description = "加载失败";
        });
    },
    getArticleDescription() {
      let me = this;
      me.companyInfo.description = "加载中...";
      
      getData("/article/description", {
        id: me.mes.id
      })
        .then((res) => {
          console.log(res);
          if (res.code == 0 && res.data) {
            me.companyInfo.description = res.data || "暂无简介";
          } else {
            me.companyInfo.description = "暂无简介";
          }
        })
        .catch((err) => {
          me.companyInfo.description = "加载失败";
        });
    },
  },
  props: {
    mes: {
      type: Object,
      default: () => ({}),
    },
    bigPic: {
      type: Boolean,
      default: false,
    },
  },
  directives: {},
  components: {
    DrawUp,
  },
  beforeDestroy() {
    this.closeImg();
  },
};
</script>

<style scoped>
.pp {
  width: 100%;
  height: 50%;
}
.head-item {
  width: 100%;
  /* height:343px; */
  background: #fff;
  margin-top: 3px;
  padding: 8px 12px 0px 16px;
  box-sizing: border-box;
  border-radius: 5px;
  position: relative;
}
.head-item-top {
  width: 100%;
}
.phone {
  width: 20px;
  height: 20px;
}
.man-pic2 {
  width: 80px;
  height: 80px;
  margin-right: 5px;
  overflow: hidden;
  position: relative;
}
.vip-dengji { margin: 0 !important;
  position: absolute;
  width: fit-content !important;
  right: 1px;
  bottom: 3px;
  font-size: 7px;
  color: #fff;
}
.man-pic2 img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.man-pic {
  width: 34px;
  height: 34px;
  margin-right: 5px;
  overflow: hidden;
  position: relative;
}
.man-pic img {
  width: 100%;
  height: 100%;
  max-width: 3rem;
  min-height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.head-item-bottom {
  height: 45px;
}
.main-mes {
  font-size: 12px;
  color: rgb(51, 51, 51);
  padding: 13px 0 12px 0;
}
.one-hour {
  color: rgb(143, 143, 143);
}
.base_info {
  text-align: left;
  margin-top: 20px;
  font-size: 12px;
  color: rgb(143, 143, 143);
}
.main-pic {
  width: 29px;
  height: 29px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-pic img {
  border-radius: 5px;
}
.main-pic img:nth-child(2) {
  width: 15px;
  height: 15px;
  margin-top: -7px;
}
.main-tag {
  margin-left: 4px;
}
.t128 {
  color: rgb(128, 128, 128);
  margin-top: 3px;
  width: 7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag-small div {
  width: 13px;
  height: auto;
  margin-right: 3px;
}
.Sh {
  display: block;
}
.Hi {
  display: none;
}
.shopBtn {
  width: 56px;
  height: 22px;
  font-size: 11px;
  color: #892785;
  text-align: center;
  display: inline-block;
  line-height: 22px;
  border: 1px solid #892785;
  border-radius: 6px;
  margin-right: 12px;
}
.optionsBtn {
  position: absolute;
  top: 40px;
  left: -12.5px;
  font-size: 12px;
}
.optionsBtn div {
  margin-top: 4px;
  padding-right: 2.5px;
  padding-top: 2.5px;
  padding-bottom: 2.5px;
  background-color: #dcdcdc;
  border-radius: 6px;
  color: #696969;
  width: 25px;
}
.company-info-popup {
  height: 100%;
  background: #fff;
}
.company-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #ebedf0;
}
.company-info-title {
  font-size: 16px;
  font-weight: 500;
}
.company-info-content {
  padding: 15px;
  overflow-y: auto;
  height: calc(100% - 50px);
}
.company-info-item {
  display: flex;
  margin-bottom: 15px;
}
.company-info-label {
  width: 70px;
  flex-shrink: 0;
  font-size: 14px;
  color: #646566;
  font-weight: 500;
}
.company-info-value {
  font-size: 14px;
  color: #323233;
  line-height: 1.5;
  text-align: left;
}
</style>
